"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    d: 'inline-flex',
    b: 0,
    mar: 0,
    bd: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
    bxz: 'border-box',
    pad: '.3em .5em',
    bdrad: '.7em',
    '&+&': {
        marl: '8px',
    },
});
const Label = ({ className, children }) => {
    const styles = (0, context_1.useStyles)();
    const light = styles.light;
    return (React.createElement("span", { className: blockClass({
            col: styles.g(0.25),
            bg: styles.g(0, 0.06),
            boxShadow: light ? 'none' : `0 0 0 1px ${styles.g(0.1, 0.16)}`,
            '&:hover': {
                col: styles.g(0.25),
                bg: styles.g(0.92),
                boxShadow: light ? 'none' : `0 0 0 1px ${styles.g(0.1, 0.24)}`,
            },
        }) + (className ? ` ${className}` : '') }, children));
};
exports.Label = Label;
